import {
    TypeService,
    MetasService
} from '@/common/api.service'
import {
    FETCH_TYPES,
    FETCH_METAS
} from '../actions.type'
import {
    SET_TYPES,
    SET_METAS
} from '../mutations.type'

const initialState = {
    types: [],
    metas: []
}
export const MODULE_NAME = 'COMMONS'

export const state = Object.assign({}, initialState)

export const actions = {
    [FETCH_TYPES] ({
        state,
        commit
    }) {
        if (state.types.length > 0) return
        return TypeService.get().then(({
            data
        }) => {
            commit(SET_TYPES, data)
        }).catch((error) => {
            throw new Error(error)
        })
    },
    [FETCH_METAS] ({
        // eslint-disable-next-line no-unused-vars
        state,
        commit
    }, params) {
        // if (state.metas.length > 0) return
        return MetasService.query(params).then(({
            data
        }) => {
            commit(SET_METAS, data)
        }).catch((error) => {
            throw new Error(error)
        })
    }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
    [SET_TYPES] (state, types) {
        state.types = types
    },
    [SET_METAS] (state, metas) {
        state.metas = metas
    }
}

const getters = {
    getTypes (state) {
        return state.types
    },
    getMetas (state) {
        return state.metas
    }
}

export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true
}
